<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    width="1000px"
    custom-class="vip-upgrade-dialog"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="vip-dialog-content">
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>

      <!-- 会员卡片容器 -->
      <div class="cards-container">
        <!-- 新锐会员 -->
        <div class="vip-card basic-vip">
          <div class="card-header">
            <h2 class="title">新锐会员</h2>
            <div class="price-btn disabled">
              <span>免费</span>
            </div>
          </div>
          <div class="card-body">
            <ul class="feature-list">
              <li>
                <i class="el-icon-circle-check icon-check"></i>
                <span>图库容量10G</span>
              </li>
              <li>
                <i class="el-icon-circle-check icon-check"></i>
                <span>创建工作流</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- 尊享会员 -->
        <div class="vip-card premium-vip">
          <div class="card-header">
            <h2 class="title">尊享会员</h2>
            <div class="price-btn active" @click="handleUpgrade(1)">
              <span class="price">3980元/年</span>
              <span class="btn-text">点击升级</span>
            </div>
          </div>
          <div class="card-body">
            <ul class="feature-list">
              <li>
                <span class="tag-new">NEW</span>
                <span>创建自有商品</span>
              </li>
              <!-- <li>
                <span class="tag-new">NEW</span>
                <span>积分充值8折</span>
              </li> -->
              <li>
                <span class="tag-new">NEW</span>
                <span>图库容量1T</span>
              </li>
              <li>
                <i class="el-icon-circle-check icon-check"></i>
                <span>创建工作流</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- 至尊会员 -->
        <div class="vip-card supreme-vip">
          <div class="card-header">
            <h2 class="title">至尊会员</h2>
            <div class="price-btn active" @click="handleUpgrade(2)">
              <span class="price">59800元/年</span>
              <span class="btn-text">点击升级</span>
            </div>
          </div>
          <div class="card-body">
            <ul class="feature-list">
              <li>
                <span class="tag-new">NEW</span>
                <span>创建自有商品</span>
              </li>
              <!-- <li>
                <span class="tag-new">NEW</span>
                <span>积分充值6折</span>
              </li> -->
              <li>
                <span class="tag-new">NEW</span>
                <span>图库容量10T</span>
              </li>
              <li>
                <span class="tag-new">NEW</span>
                <span>独立域名</span>
              </li>
              <li>
                <span class="tag-new">NEW</span>
                <span>专属后台</span>
              </li>
              <li>
                <span class="tag-new">NEW</span>
                <span>分销体系</span>
              </li>
              <li>
                <span class="tag-new">NEW</span>
                <span>轮播图</span>
              </li>
              <li>
                <i class="el-icon-circle-check icon-check"></i>
                <span>创建工作流</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VipUpgradeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    handleUpgrade(type) {
      this.$emit('upgrade', type);
      // 可以在这里处理升级逻辑
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .vip-upgrade-dialog {
  background: transparent !important;
  box-shadow: none !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}

.vip-dialog-content {
  position: relative;
  width: fit-content;
  margin: 0 auto;

  .close-btn {
    position: absolute;
    top: -10px;
    right: -40px;
    width: 32px;
    height: 32px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s;

    i {
      color: #fff;
      font-size: 18px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      transform: rotate(90deg);
    }
  }

  .cards-container {
    display: flex;
    justify-content: center;
    gap: 20px;

    .vip-card {
      width: 300px;
      background: #fff;
      border-radius: 24px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      min-height: 450px;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
      }

      .card-header {
        height: 160px;
        padding: 30px 20px 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        background: linear-gradient(180deg, var(--header-bg) 0%, #ffffff 100%);

        .title {
          margin: 0 0 24px 0;
          font-size: 26px;
          font-weight: bold;
          color: var(--theme-color);
          letter-spacing: 1px;
        }

        .price-btn {
          width: 240px;
          height: 44px;
          border-radius: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

          &.disabled {
            background: #f2f2f2;
            color: #cccccc;
            cursor: not-allowed;
            box-shadow: none;
          }

          &.active {
            background: var(--btn-bg);
            color: #fff;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              opacity: 0.9;
              box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
            }

            .price {
              margin-right: 12px;
              position: relative;

              &::after {
                content: '';
                position: absolute;
                right: -8px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 14px;
                background: rgba(255, 255, 255, 0.5);
              }
            }
            
            .btn-text {
              margin-left: 4px;
            }
          }
        }
      }

      .card-body {
        padding: 10px 30px 0;
        flex: 1;

        .feature-list {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            font-size: 15px;
            color: #444;

            .icon-check {
              color: #00d1bb;
              font-size: 20px;
              margin-right: 12px;
            }

            .tag-new {
              background: linear-gradient(90deg, #0090ff, #00d1bb);
              color: #fff;
              font-size: 10px;
              padding: 1px 5px;
              border-radius: 3px;
              margin-right: 10px;
              font-weight: bold;
              height: 16px;
              line-height: 16px;
              display: inline-flex;
              align-items: center;
              box-shadow: 0 2px 4px rgba(0, 144, 255, 0.2);
            }
          }
        }
      }

      &.basic-vip {
        --theme-color: #0090ff;
        --header-bg: rgba(0, 144, 255, 0.15);
      }

      &.premium-vip {
        --theme-color: #7b5df6;
        --header-bg: rgba(123, 93, 246, 0.15);
        --btn-bg: #8b73f1;
      }

      &.supreme-vip {
        --theme-color: #f59a23;
        --header-bg: rgba(245, 154, 35, 0.15);
        --btn-bg: linear-gradient(90deg, #f59a23 0%, #ff6b6b 100%);
      }
    }
  }
}
</style>